import actionCreatorFactory from "typescript-fsa";
import { MembershipRequestBody } from "../../core/api/requests/auth/membership/types";
import { CouponCheckRequestBody } from "../../core/api/requests/coupon/check/types";
import { CouponExternalRequestBody } from "../../core/api/requests/coupon/external/types";
import { CouponLimitedRequestBody } from "../../core/api/requests/coupon/limited/types";
import { CouponRedeemRequestBody } from "../../core/api/requests/coupon/redeem/types";
import { CouponValidateRequestBody } from "../../core/api/requests/coupon/validate/types";
import { MenuLimitedRequestBody } from "../../core/api/requests/menu/limited/types";
import { CommonAsyncType } from "../../core/types";
import { MenuInCart } from "../menu";
import { AppCoupon, AppliedCoupon, Coupon, CouponExternal, MenuExternalCoupon } from "./types";

const actionCreator = actionCreatorFactory("@@Coupon");

export const couponActions = {
  getCoupons: actionCreator.async<CommonAsyncType, Coupon[]>("GET_COUPONS"),
  getCouponExternals: actionCreator.async<CommonAsyncType & CouponExternalRequestBody, { coupons: CouponExternal[]; remainingSlot: number }>(
    "GET_COUPON_EXTERNALS",
  ),
  getAppliedCoupons: actionCreator.async<
    CommonAsyncType,
    { appliedCoupons: AppliedCoupon[]; unselectedAppCoupons: string[] | null; selectedAppCoupons: AppCoupon[] | null }
  >("GET_APPLIED_COUPONS"),
  removeAppliedCoupon: actionCreator.async<CommonAsyncType & { couponUuids: string[] }, AppliedCoupon[]>("REMOVE_APPLIED_COUPON"),
  validateCoupon: actionCreator.async<CommonAsyncType<{ success: string[]; errors: string[] }> & CouponValidateRequestBody, {}>("VALIDATE_COUPON"),
  redeemCoupon: actionCreator.async<CommonAsyncType & CouponRedeemRequestBody, string[]>("REDEEM_COUPON"),
  applyCoupon: actionCreator.async<
    CommonAsyncType<{ couponMenus: MenuInCart[]; appliedCoupons: AppliedCoupon[] }> &
      MenuLimitedRequestBody & { isAppCoupon?: boolean; menuExternalCoupons?: MenuExternalCoupon[] },
    {}
  >("APPLY_COUPON"),
  checkAppliedCouponMenu: actionCreator.async<
    CommonAsyncType<MenuInCart[]> & CouponCheckRequestBody & { couponMenus: MenuInCart[]; appliedCoupons: AppliedCoupon[]; isAppCoupon?: boolean },
    AppliedCoupon[]
  >("CHECK_APPLIED_COUPON_MENU"),
  getLimitedCoupons: actionCreator.async<CommonAsyncType<AppCoupon[]> & CouponLimitedRequestBody, AppCoupon[]>("GET_LIMITED_COUPONS"),
  saveSelectedAppCoupon: actionCreator.async<
    CommonAsyncType<string[]> & { coupon: AppCoupon },
    { unselectedAppCoupons: string[]; selectedAppCoupons: AppCoupon[] }
  >("SAVE_SELECTED_APP_COUPON"),
  removeSelectedAppCoupon: actionCreator.async<CommonAsyncType<string[]> & { couponCodes: string[] }, AppCoupon[] | null>("REMOVE_SELECTED_APP_COUPON"),
  removeAllAppCoupons: actionCreator.async<CommonAsyncType<string[]>, {}>("REMOVE_ALL_APP_COUPONS"),
  clearCoupons: actionCreator.async<CommonAsyncType, {}>("CLEAR_COUPONS"),
  linkAppMembership: actionCreator.async<CommonAsyncType<{ appToken: string }> & MembershipRequestBody, { appToken: string }>("LINK_APP_MEMBERSHIP"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
